<owc-modal-dialog disable-backdrop-click disable-escape-keydown hide-backdrop no-auto-focus visible *transloco="let t; read: 'liatActivation.keyGenerationModule'">
    <owc-component-header slot="header">
        <div class="header-right-section">
            <h3>{{ t('keyGenerationTitle') }}</h3>
            <div class="action-icons">
                <owc-icon-button icon="print" (click)="printPage()"></owc-icon-button>
            </div>
        </div>
    </owc-component-header>
    <div class="modal-content">
        <p>
            {{ t('paragraph1')}}
        </p>
        <p class="error-text">
            {{ t('paragraph2Error')}}
        </p>
        <div id="activation-table" *ngIf="dataSource && dataSource.length > 0">
            <owc-table [size]="'small'" class="activation-table">
                <owc-table-header sticky>
                    <owc-table-header-cell [width]="'33%'" [align]="'left'" [resizable]="true" [sortable]="false"
                        [sortOrder]="'asc'" [valign]="'middle'">{{ t('tableHeader1')}}</owc-table-header-cell>
                    <owc-table-header-cell [width]="'33%'" [align]="'left'" [resizable]="true" [sortable]="false"
                        [sortOrder]="'asc'" [valign]="'middle'">{{ t('tableHeader2')}}</owc-table-header-cell>
                    <owc-table-header-cell [width]="'33%'" [align]="'left'" [resizable]="true" [sortable]="false"
                        [sortOrder]="'asc'" [valign]="'middle'">{{ t('tableHeader3')}}</owc-table-header-cell>
                </owc-table-header>
                <owc-table-body>
                    <owc-table-row *ngFor="let data of dataSource">
                        <owc-table-cell>{{data.additionalInput}}</owc-table-cell>
                        <owc-table-cell>{{data.token}}</owc-table-cell>

                        <owc-table-cell>
                            <img *ngIf="data.tokenBarcode" src="data:image/gif;base64,{{data.tokenBarcode}}"
                                alt="Barcode" height="20px" />
                        </owc-table-cell>
                    </owc-table-row>
                </owc-table-body>
            </owc-table>

            <div class="activation-table-mobile" *ngIf="dataSource && dataSource.length > 0">
                <div *ngFor="let data of dataSource">
                    <div>
                        <span class="header-label">Registeration Key: </span>
                        <span>{{data.additionalInput}}</span>
                    </div>
                    <div>
                        <span class="header-label">Token: </span>
                        <span>{{data.token}}</span>
                    </div>
                    <div *ngIf="data.tokenBarcode" class="margin-top-5">
                        <span class="header-label">Barcode:</span>
                        <img *ngIf="data.tokenBarcode" src="data:image/gif;base64,{{data.tokenBarcode}}" alt="Barcode"
                            height="20px" />
                    </div>
                    <hr/>
                </div>
            </div>
        </div>
    </div>
    <owc-component-footer slot="footer">
        <div class="action-button">
            <owc-button (click)="closePopup()">{{ t('buttonClose')}}</owc-button>
        </div>
    </owc-component-footer>
</owc-modal-dialog>

<div id="print-section" style="display: none;">
    <dl-print-registration-key [tableData]="dataSource"></dl-print-registration-key>
</div>